import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetDbAppSettings = () => {
    return useQuery({
        queryKey: ['get-db-app-settings'],
        queryFn: async () => {
            const response = await _apiClient.getDBAppSettings();

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve App Settings.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
